module.exports = __webpack_public_path__ + "static/media/34.eaa1804a.jpg";